oyc.FileUpload = {
  selector: {
    container: '#apply',
    multipleUpload: '#application-form-applicationFiles'
  },
  container: null,
  upload: null,
  init: function () {
    this.container = $(this.selector.container);
    if (0 < this.container.length) {
      if (location.hash === this.selector.container || location.hash === '#application-form') {
        this.container.attr('open', true);
        document.querySelector(this.selector.container).scrollIntoView({behavior: "smooth"});
      }
      if (this.container.offset().top > window.scrollY + (parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0)) {
        document.addEventListener("scrollend", this.scrollFormIntoView.bind(this), {once: true});
      }
      this.upload = $(this.selector.multipleUpload);
      oyc.AssetLoader.loadAsset('/_assets/bda1ba5cb481e7eb4a0c6d4681a46dce/Js/Vendor/jquery.fileuploader.min.js')
        .then(this.initField.bind(this, undefined));
    }
  },
  scrollFormIntoView: function () {
    if (location.hash === this.selector.container) {
      const rect = this.container.offset();
      const offsetY = window.scrollY || window.pageYOffset; // Aktueller Scroll-Offset
      const scrollPadding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;

      // Prüfen, ob das Ziel exakt an der vorgesehenen Position ist
      if (rect.top > offsetY + scrollPadding) {
        // Ziel erneut an den oberen Rand (unter Berücksichtigung von scroll-padding) scrollen
        window.scrollTo({
          top: rect.top - scrollPadding,
          behavior: "smooth"
        });
      }
    }
  },
  initField: function (containerSelector) {
    if (typeof containerSelector !== 'undefined') {
      let container = $(containerSelector);
      if (container.length) {
        this.upload = container;
      }
    }

    let options = {
      changeInput: '<div class="fileuploader-input">' +
        '<div class="fileuploader-input-inner">' +
        '<div><span><i class="icon"></i> ${captions.button}</span> ${captions.or} ${captions.feedback} </div>' +
        '</div>' +
        '</div>',
      theme: 'dropin',
      captions: $.extend(true, {}, $.fn.fileuploader.languages['de'], {
        feedback: 'per Drag-and-Drop hierher ziehen',
        or: 'oder',
        button: 'Datei auswählen'
      })
    }

    // enable fileuploader plugin for multiple file upload
    options.addMore = true;
    this.upload.fileuploader(options);
  }
}
